var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 26C52 11.64 40.36 0 26 0S0 11.64 0 26s11.64 26 26 26 26-11.64 26-26z",
    fill: "#FDE502"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.31 13.681c-7.429 0-13.446 4.668-13.446 10.437 0 3.578 2.327 6.748 5.868 8.667l-1.485 5.485a.544.544 0 0 0 .842.581l6.537-4.333c.544 0 1.114.087 1.683.087 7.43 0 13.446-4.68 13.446-10.437 0-5.758-6.017-10.438-13.446-10.438",
    fill: "#191600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakao);
export default __webpack_public_path__ + "static/media/kakao.1ddb7cd441b8a823ed9ecdd5d8bc1fd6.svg";
export { ForwardRef as ReactComponent };